import { Divider, Grid2, Paper } from "@mui/material";
import classnames from "classnames";
import { get } from "lodash";
import React, { useEffect } from "react";
import { ApiSearchForm } from "./container";

export function ListItem({ filmRelease, onSelectFilm }) {
    const { title, companyId, deliverySystem } = filmRelease;

    const rating = get(filmRelease, "filmRatingTypeId.abbreviation", "");
    const release = get(filmRelease, "filmReleaseTypeId.abbreviation", "");
    const releaseDate = get(filmRelease, "enteredDateFormatted", null);

    function handleClick() {
        onSelectFilm(filmRelease);
    }

    const companyName = get(companyId, "name", "");
    return (
        (<Grid2 className={classnames("settings-tag-list-item")} container onClick={handleClick}  size={12}>
            <Grid2 size={4}>
                {title}
            </Grid2>
            <Grid2 size={3}>
                {companyName}
            </Grid2>
            <Grid2 size={1}>
                {rating}
            </Grid2>
            <Grid2 size={2}>
                {releaseDate}
            </Grid2>
            <Grid2 size={1}>
                {release}
            </Grid2>
            <Grid2 size={1}>
                {deliverySystem}
            </Grid2>
        </Grid2>)
    );
}
function List({ list, onSelectFilm, selectedFilmId, loadFilms }) {
    useEffect(() => {
        loadFilms();
    }, [loadFilms]);

    return (
        (<Paper>
            <Grid2 contianer spacing={1}>
                <Grid2 padding={5} size={12}>
                    <ApiSearchForm />
                </Grid2>
                <Divider />

                <Grid2
                    padding={5}
                    style={{ display: "block", maxHeight: "calc(100vh - 180px)", overflowY: "auto" }}
                    container
                    size={12}
                >
                    {list.map((filmRelease) => {
                        const selected = filmRelease.id === selectedFilmId;
                        return (
                            (<Grid2
                                className={classnames("stripe-row", "grid-item", { selected })}
                                key={filmRelease.id}
                                size={12}
                            >
                                <ListItem filmRelease={filmRelease} onSelectFilm={onSelectFilm} />
                            </Grid2>)
                        );
                    })}
                </Grid2>
            </Grid2>
        </Paper>)
    );
}

export default List;
